import { render, staticRenderFns } from "./SearchNew.vue?vue&type=template&id=8100e38a&scoped=true&"
import script from "./SearchNew.vue?vue&type=script&lang=js&"
export * from "./SearchNew.vue?vue&type=script&lang=js&"
import style0 from "./SearchNew.vue?vue&type=style&index=0&id=8100e38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8100e38a",
  null
  
)

export default component.exports